"use strict";

angular.module("customer")
.component("discountIcon", {
    bindings: {
        discountType: "<"
    },
    templateUrl: require("./discount-icon.component.html"),
    controllerAs: "discountIconCtrl"
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/discount-icon/discount-icon.component.js
// module id = 849
// module chunks = 0